import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import qs from 'query-string';
import React, { useEffect } from 'react';

import { clearAppSessionStorage, setLegacyAuthProvider } from '@commons/auth/session';
import { setLocalStorageItem } from '@commons/utils/localStorage';

import { loading, loadingSuccess } from '@actions/loading';

import { user as userService } from '@services/user';

const ClientLogin = (props) => {
  const { pageLoading, pageLoaded } = props;

  const history = useHistory();

  const getUser = async () => {
    pageLoading();

    try {
      const { accessToken } = qs.parse(location.search);

      clearAppSessionStorage();

      if (!accessToken) {
        history.push('/login');
        return;
      }

      setLocalStorageItem('loopbackAccessToken', accessToken);
      setLegacyAuthProvider();

      const user = await userService.isAuthenticated();

      setLocalStorageItem('userId', user.id);

      history.push('/');
    } catch {
      history.push('/login');
    } finally {
      pageLoaded();
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  return <></>;
};

const mapDispatchToProps = (dispatch) => ({
  pageLoading: () => {
    dispatch(loading());
  },
  pageLoaded: () => {
    dispatch(loadingSuccess());
  },
});

export default connect(null, mapDispatchToProps)(ClientLogin);
